module.exports = __webpack_public_path__ + "img/tiktok.c2e82e85.svg";